<template>
	<div class="eth_recharge_wrap">
		<div class="red_top_bg">
			<div class="back_left" @click="$router.back()"></div>
			<div class="big_tit">{{ $t('ethRecharge.title') }}</div>
		</div>

		<div class="box">
			<div class="addr_section">
				<div class="label">{{ $t('ethRecharge.address') }}</div>
				<div class="qr_wrap" v-if="qrcode">
					<img class="qr_img" :src="fixUrl(qrcode)" alt="">
				</div>
				<div class="addr">{{ address || $t('ethRecharge.notConfigured') }}</div>
				<div class="copy_btn" @click="copyText(address)" v-if="address">
					{{ $t('ethRecharge.copyAddress') }}
				</div>
			</div>

			<div class="form_section">
				<div class="form_item">
					<span class="form_label">{{ $t('ethRecharge.amount') }}</span>
					<input v-model="amount" type="number" step="0.0001" :placeholder="$t('ethRecharge.amountPlaceholder')">
					<span class="unit">ETH</span>
				</div>
				<div class="form_item">
					<span class="form_label">{{ $t('ethRecharge.txHash') }}</span>
					<input v-model="txHash" type="text" :placeholder="$t('ethRecharge.txHashPlaceholder')">
				</div>
			</div>

			<div class="tips">
				<p>{{ $t('ethRecharge.tip1') }}</p>
				<p>{{ $t('ethRecharge.tip2') }}</p>
				<p>{{ $t('ethRecharge.tip3') }}</p>
				<p>{{ $t('ethRecharge.tip4') }}</p>
			</div>

			<div class="btn_wrap">
				<van-button
					type="primary"
					class="submit_btn"
					:loading="loading"
					@click="submit"
				>
					{{ $t('ethRecharge.submit') }}
				</van-button>
			</div>
		</div>
	</div>
</template>

<script>
import Fetch from '../../utils/fetch';

export default {
	name: 'ethrecharge',
	data() {
		return {
			address: '',
			qrcode: '',
			amount: '',
			txHash: '',
			loading: false
		};
	},
	created() {
		this.getInfo();
	},
	methods: {
		fixUrl(url) {
			if (!url) return '';
			if (url.startsWith('//')) return 'https:' + url;
			return url;
		},
		getInfo() {
			Fetch('/exchange/ethRechargeInfo').then(res => {
				this.address = res.data.address;
				this.qrcode = res.data.qrcode;
			});
		},
		copyText(text) {
			if (!text) return;
			const input = document.createElement('input');
			input.value = text;
			document.body.appendChild(input);
			input.select();
			document.execCommand('copy');
			document.body.removeChild(input);
			this.$toast(this.$t('ethRecharge.copied'));
		},
		submit() {
			const amount = Number(this.amount || 0);
			if (!amount || amount <= 0) {
				this.$toast(this.$t('ethRecharge.inputAmount'));
				return;
			}
			if (!this.txHash) {
				this.$toast(this.$t('ethRecharge.inputTxHash'));
				return;
			}

			this.loading = true;
			Fetch('/exchange/ethRechargeSubmit', {
				amount: amount,
				tx_hash: this.txHash
			}).then(() => {
				this.$toast(this.$t('ethRecharge.success'));
				setTimeout(() => {
					this.$router.back();
				}, 1500);
			}).catch(err => {
				const msg = err && err.msg ? err.msg : this.$t('ethRecharge.fail');
				this.$toast(typeof msg === 'object' ? msg[this.$i18n.locale] : msg);
			}).finally(() => {
				this.loading = false;
			});
		}
	}
};
</script>

<style lang="less" scoped>
.eth_recharge_wrap {
	min-height: 100vh;
	background: #f5f6fa;
}

.box {
	width: 92%;
	margin: 20px auto;
}

.addr_section {
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	text-align: center;

	.label {
		font-size: 14px;
		color: #999;
		margin-bottom: 12px;
	}

	.qr_wrap {
		margin-bottom: 16px;

		.qr_img {
			width: 180px;
			height: 180px;
			display: block;
			margin: 0 auto;
			border-radius: 8px;
		}
	}

	.addr {
		font-size: 14px;
		color: #222;
		word-break: break-all;
		line-height: 1.6;
		margin-bottom: 12px;
	}

	.copy_btn {
		display: inline-block;
		padding: 6px 20px;
		background: #222;
		color: #fff;
		border-radius: 16px;
		font-size: 13px;
		cursor: pointer;
	}
}

.form_section {
	background: #fff;
	border-radius: 12px;
	padding: 20px;
	margin-top: 12px;
}

.form_item {
	display: flex;
	align-items: center;
	padding: 12px 0;
	border-bottom: 1px solid #f0f0f0;

	&:last-child {
		border-bottom: none;
	}

	.form_label {
		width: 80px;
		font-size: 14px;
		color: #666;
	}

	input {
		flex: 1;
		border: none;
		outline: none;
		font-size: 15px;
		background: transparent;
	}

	.unit {
		font-size: 14px;
		color: #666;
		margin-left: 8px;
	}
}

.tips {
	background: #fff;
	border-radius: 12px;
	padding: 16px 20px;
	margin-top: 12px;

	p {
		font-size: 12px;
		color: #999;
		line-height: 1.8;
	}
}

.btn_wrap {
	display: flex;
	justify-content: center;
	margin-top: 30px;
}

.submit_btn {
	width: 260px;
	height: 48px;
	border-radius: 24px;
	font-size: 16px;
	font-weight: 600;
	background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
	border: none;
	box-shadow: 0 8px 20px rgba(102, 126, 234, 0.35);
	display: flex;
	align-items: center;
	justify-content: center;
	line-height: 1;
	padding: 0;

	::v-deep .van-button__content {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		height: 100%;
	}

	::v-deep .van-button__text {
		line-height: 1;
	}
}
</style>